export default __webpack_public_path__ + "static/media/hand-paper-blk.def6a061.svg";